import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledDropzoneIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 84,
	height: 83,
	viewBox: "0 0 84 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.899 71.0607C63.9598 71.0607 63.1914 70.2966 63.1914 69.3628V61.8662C63.1914 60.9323 63.9598 60.1682 64.899 60.1682H72.349C73.2882 60.1682 74.0567 60.9323 74.0567 61.8662V69.3628C74.0567 70.2966 73.2882 71.0607 72.349 71.0607H64.899Z",
			fill: "#F4F8FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.0726 10.335H34.4066C32.0018 10.335 30.0523 12.2844 30.0523 14.6892V48.4614C30.0523 50.8662 32.0018 52.8157 34.4066 52.8157H68.0726C70.4774 52.8157 72.4268 50.8662 72.4268 48.4614V14.6892C72.4268 12.2844 70.4774 10.335 68.0726 10.335Z",
			fill: "#9D9D9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.0082 25.1986C40.808 25.1986 40.6459 24.9431 40.6459 24.6274V22.3429C40.6459 22.0277 40.808 21.7722 41.0082 21.7722H51.149C51.3492 21.7722 51.5112 22.0277 51.5112 22.3429V24.6274C51.5112 24.9431 51.3492 25.1986 51.149 25.1986H41.0082Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M66.9036 33.3678H41.5515C41.051 33.3678 40.6459 33.1123 40.6459 32.7966V30.512C40.6459 30.1969 41.051 29.9414 41.5515 29.9414H66.9036C67.4041 29.9414 67.8091 30.1969 67.8091 30.512V32.7966C67.8091 33.1123 67.4041 33.3678 66.9036 33.3678Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.3704 41.5372C40.97 41.5372 40.6459 41.2817 40.6459 40.9661V38.6815C40.6459 38.3663 40.97 38.1108 41.3704 38.1108H61.652C62.0524 38.1108 62.3765 38.3663 62.3765 38.6815V40.9661C62.3765 41.2817 62.0524 41.5372 61.652 41.5372H41.3704Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.8733 29.6692H16.2073C13.8025 29.6692 11.853 31.6187 11.853 34.0234V67.7957C11.853 70.2004 13.8025 72.1499 16.2073 72.1499H49.8733C52.2781 72.1499 54.2275 70.2004 54.2275 67.7957V34.0234C54.2275 31.6187 52.2781 29.6692 49.8733 29.6692Z",
			fill: "#DEDEDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2073 29.6692H49.8733C52.2781 29.6692 54.2275 31.6187 54.2275 34.0234V39.6774H11.853V34.0234C11.853 31.6187 13.8025 29.6692 16.2073 29.6692Z",
			fill: "#BBBBBB"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_256_2652)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M40.3148 52.665C39.6348 49.215 36.6048 46.625 32.9648 46.625C30.0748 46.625 27.5648 48.265 26.3148 50.665C23.3048 50.985 20.9648 53.535 20.9648 56.625C20.9648 59.935 23.6548 62.625 26.9648 62.625H39.9648C42.7248 62.625 44.9648 60.385 44.9648 57.625C44.9648 54.985 42.9148 52.845 40.3148 52.665ZM34.9648 55.625V59.625H30.9648V55.625H27.9648L32.9648 50.625L37.9648 55.625H34.9648Z",
				fill: "url(#paint0_linear_256_2652)"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M67.725 61.241V61.9963L61.3045 61.9963V61.241H59.4581V63.0874H61.3045V62.3321L66.6282 62.332C63.7858 63.1702 61.6636 65.6909 61.4103 68.7431C60.9698 68.8131 60.6331 69.1946 60.6331 69.6549C60.6331 70.1648 61.0464 70.5781 61.5563 70.5781C62.0662 70.5781 62.4795 70.1648 62.4795 69.6549C62.4795 69.2102 62.1652 68.8389 61.7465 68.7512C62.0256 65.4994 64.5288 62.884 67.725 62.4378V63.0874H69.5715V62.4248C72.8148 62.8308 75.3667 65.4671 75.648 68.7527C75.2328 68.843 74.9219 69.2126 74.9219 69.6549C74.9219 70.1648 75.3352 70.5781 75.8451 70.5781C76.355 70.5781 76.7683 70.1648 76.7683 69.6549C76.7683 69.1922 76.428 68.8089 75.984 68.742C75.7303 65.6903 73.6082 63.1701 70.7662 62.332L76.0709 62.3321V63.0874H77.9173V61.241H76.0709V61.9963L69.5715 61.9963V61.241H67.725ZM68.0607 61.5767H69.2357V62.7517H68.0607V61.5767ZM59.7938 62.7517V61.5767H60.9688V62.7517H59.7938ZM76.4066 61.5767H77.5816V62.7517H76.4066V61.5767ZM60.9688 69.6549C60.9688 69.3304 61.2318 69.0673 61.5563 69.0673C61.5591 69.0673 61.562 69.0673 61.5648 69.0674C61.8853 69.0719 62.1438 69.3332 62.1438 69.6549C62.1438 69.9794 61.8807 70.2424 61.5563 70.2424C61.2318 70.2424 60.9688 69.9794 60.9688 69.6549ZM75.8311 69.0675C75.8335 69.0674 75.8359 69.0674 75.8382 69.0673C75.8398 69.0673 75.8413 69.0673 75.8428 69.0673L75.8451 69.0673C76.1696 69.0673 76.4326 69.3304 76.4326 69.6549C76.4326 69.9794 76.1696 70.2424 75.8451 70.2424C75.5207 70.2424 75.2576 69.9794 75.2576 69.6549C75.2576 69.335 75.5132 69.0749 75.8311 69.0675Z",
			fill: "#BBBBBB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.4287 75.2745L68.7077 65.8325L63.9867 75.2745H73.4287Z",
			fill: "#BBBBBB"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .3,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M4.64899 8.76641C5.37929 9.4967 6.56335 9.49668 7.29367 8.76636C8.02399 8.03604 8.02401 6.85197 7.29372 6.12168C6.56343 5.39139 5.37936 5.39141 4.64904 6.12173C3.91872 6.85205 3.9187 8.03611 4.64899 8.76641Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.3816 24.7519C21.1119 25.4822 22.2959 25.4822 23.0262 24.7519C23.7565 24.0216 23.7565 22.8375 23.0262 22.1072C22.2959 21.3769 21.1119 21.3769 20.3816 22.1072C19.6513 22.8375 19.6513 24.0216 20.3816 24.7519Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9.92264 12.7841C11.8073 10.8995 14.8628 10.8995 16.7474 12.7841C18.632 14.6687 18.632 17.7243 16.7474 19.6089C14.8628 21.4935 11.8072 21.4935 9.92259 19.6089C8.03799 17.7243 8.03801 14.6688 9.92264 12.7841Z",
					fill: "#656565"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.6282 13.9047C27.6282 14.9375 26.791 15.7748 25.7582 15.7748C24.7254 15.7748 23.8882 14.9375 23.8882 13.9047C23.8882 12.8719 24.7254 12.0347 25.7582 12.0347C26.791 12.0347 27.6282 12.8719 27.6282 13.9047Z",
					fill: "#656565"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_256_2652",
			x1: 32.9648,
			y1: 46.625,
			x2: 32.9648,
			y2: 62.625,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606060" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#373737"
			})]
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_256_2652",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(20.9648 42.625)"
			})
		})] })
	]
});
export default SvgDisabledDropzoneIcon;
